module.exports = __webpack_public_path__ + "img/55.maintenance_fixed.f1ec4136.svg";